import React from 'react';
import PropTypes from 'prop-types';

import {Field, Form} from 'formik';

import SubmitFormGroup from 'components/SubmitFormGroup';

import {Box, SimpleGrid} from '@mantine/core';

import {PacFormikPasswordInput} from 'pac-platform-ui-components';

const FormComponent = (props) => {
    return (
        <Form onSubmit={props.handleSubmit}>
            <SimpleGrid>
                <Box>
                    <Field
                        name="otc"
                        placeholder="One Time Code (OTC)"
                        component={PacFormikPasswordInput}
                    />
                </Box>

                <Box>
                    <Field
                        name="new_password"
                        placeholder="New Password"
                        component={PacFormikPasswordInput}
                    />
                </Box>

                <Box>
                    <Field
                        name="confirm_password"
                        placeholder="Confirm Password"
                        component={PacFormikPasswordInput}
                    />
                </Box>

                <Box>
                    <SubmitFormGroup
                        cancelUrl="/"
                        disabled={props.isSubmitting}
                        submitButtonLabel="Next"
                    />
                </Box>
            </SimpleGrid>
        </Form>
    );
};

FormComponent.propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
};

export default FormComponent;
